import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import type { AccessCentreUserByIdApiResponse } from 'domains/accessCentre/types';

const useGetUserById = (userId: string, reactQueryOptions?: UseQueryOptions<AccessCentreUserByIdApiResponse, Error>) =>
    useQuery<AccessCentreUserByIdApiResponse>(
        QueryKeys.ACCESS_CENTRE_USER_ID(userId),
        new PathWithID(CuredApiPaths.ACCESS_CENTRE_USERS, userId),
        reactQueryOptions
    );

export default useGetUserById;
